import React from "react";
import { Link } from "react-router-dom";

const MainBodyTabs = ({ tabs, match }) => {
  const renderPath = (e) => {
    if (e.urlParams) return `${e.path}?${e.urlParams}`;

    console.log(e.params);
    return e.path;
  };

  return (
    <div className="main-body-tab-area">
      <ul>
        {tabs &&
          tabs.map((tab, i) => (
            <Link key={i} to={renderPath(tab)}>
              <li
                key={i}
                className={tab.path == match.params.path ? "active" : ""}
              >
                {tab.name}
              </li>
            </Link>
          ))}
      </ul>
    </div>
  );
};

export default MainBodyTabs;
